var React = require('react');

function Restaurant (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z","fill":"black","key":0}),React.createElement("path",{"d":"M16.35 16.45H18.45C18.45 10.85 17.47 7 16.5033 7H16.35V21.35","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M9.34998 7.7V10.5C9.34998 11.6599 10.2901 12.6 11.45 12.6C12.6092 12.6 13.55 11.6599 13.55 10.5V7.7","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M11.45 7.7V21.35","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Restaurant.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Restaurant;

Restaurant.default = Restaurant;
